import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  text: {
    textAlign: "center",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
};
